import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { it } from 'date-fns/locale';

const LocalizationWrapper = ({ children }) => {
  return (
    <LocalizationProvider 
      dateAdapter={AdapterDateFns} 
      adapterLocale={it}
      dateFormats={{ 
        keyboardDate: 'dd/MM/yyyy',
        keyboardDateTime: 'dd/MM/yyyy HH:mm',
        shortDate: 'dd/MM/yyyy',
        fullDate: 'dd MMMM yyyy',
        fullDateTime: 'dd/MM/yyyy HH:mm'
      }}
    >
      {children}
    </LocalizationProvider>
  );
};

export default LocalizationWrapper; 